import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getAllDashboardSummaryCount = async (
  token,
  startDate = null || undefined,
  endDate = null || undefined
) => {
  try {
    const endpoint =
      startDate && endDate
        ? `/api/v1/analytics/dashboard/summary?start_date=${startDate}&end_date=${endDate}`
        : `/api/v1/analytics/dashboard/summary`;
    const response = await fetch(
      // eslint-disable-next-line no-undef

      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data?.payload;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
